// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3nIcP","content":"RecentSearches_content__3rlyk"};